import { useEffect } from "react";
import { EnumTranslationsCard } from "./card";
import { EnumTranslationsNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { EnumTranslationsTable } from "./table";

export default function EnumTranslation() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Traductions d'énumérations");
  }, []);

  return (
    <Routes>
      <Route index element={<EnumTranslationsTable />} />
      <Route path="/new" element={<EnumTranslationsNew />} />
      <Route path=":id" element={<EnumTranslationsCard />} />
    </Routes>
  );
}
